
const canAddListener
  = window.Soda && window.Soda.setLocationListener

let listeners = []

export function addListener(callback) {
  if (!callback || !canAddListener) return

  if (!listeners.includes(callback)) {
    listeners.unshift(callback)
  }

  return {
    remove() {
      removeListener(callback)
    }
  }
}

export function removeListener(callback) {
  listeners = listeners.filter(it => it !== callback)
}

export function onceListener(callback) {
  if (!callback || !canAddListener) return
  const handler = function(...args) {
    removeListener(handler)
    return callback(...args)
  }

  listeners.unshift(handler)
  return {
    remove() {
      removeListener(handler)
    }
  }
}

export function uninit() {
  window.Soda && window.Soda.setLocationListener && window.Soda.setLocationListener(false)
}

export function init() {
  if (canAddListener) {
    window.Soda.setLocationListener(true, function(result = {}) {
      const {data} = result || {}
      listeners.reduce(async (excuteNextHandler, handler) => {
        if (excuteNextHandler) {
          const canNext = await handler(data)
          return canNext
        }
        return false
      }, true)
    })
  }
}

export default {
  init,
  uninit,
  addListener,
  removeListener,
  onceListener
}
